<template>
  <PublicLayout>
    <h1 class="public__title">Contact</h1>
    <p class="public__lead">
      Une question, une demande de partenariat ou un retour sur Saineo ? Nous sommes là pour vous aider.
    </p>

    <h2 class="public__section-title">Nous écrire</h2>
    <p class="public__text">
      Envoyez-nous un message à <strong>contact@saineo.fr</strong>. Nous répondons généralement sous 48h ouvrées.
    </p>

    <h2 class="public__section-title">Support produit</h2>
    <ul class="public__list">
      <li>Problème de connexion ou d’inscription</li>
      <li>Question sur les menus ou les filtres nutritionnels</li>
      <li>Signalement d’un contenu à corriger</li>
    </ul>
  </PublicLayout>
</template>

<script>
import PublicLayout from './PublicLayout.vue';

export default {
  name: 'ContactPage',
  components: { PublicLayout },
};
</script>
